import request from "../utils/request";


const schemeApi = {
    SchemeList: 'filtrate/filter/result',
    patient: 'confirmed/filter/result',
}
export function filtrate(parameter) {
    return request({
        url: schemeApi.SchemeList,
        method: "post",
        data: parameter,

    })
}




export function confirmedFiltrate(parameter) {
    return request({
        url: schemeApi.patient,
        method: "post",
        data: parameter,

    })
}